module.exports = __webpack_public_path__ + "static/media/twitter-share.c5396306.svg";